// E-Ticaret › Sayfalar (özel sayfalar) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.pages';

export const ecommercePagesGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Sayfalar nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizde göstermek istediğiniz özel sayfaları (örn. Franchise, Kariyer, Gizlilik Politikası) burada oluşturur ve yönetirsiniz. Her sayfa üstte bir sekme olarak görünür; sekmeye tıklayınca o sayfanın ayarları açılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Sayfalar'),
    tabs: t(`${G}.regions.tabs`, 'Sayfa sekmeleri ve +'),
    body: t(`${G}.regions.body`, 'Genel Bilgiler, Geçiş, SEO, İçerik'),
    footer: t(`${G}.regions.footer`, 'Sayfayı Sil / Sıfırla / Kaydet'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sayfa oluşturun'),
      text: t(`${G}.s1.text`, 'Sekmelerin sağındaki + düğmesi (Yeni Sayfa Ekle) "Yeni Sayfa" adlı boş bir sayfa açar. Sayfa "Kaydet"e basılana kadar kaydedilmez; kaydedilmemiş sayfanın sekmesinde turuncu nokta, başlığında "Kaydedilmedi" etiketi görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sekmedeki göz kapalı simgesi sayfanın Pasif olduğunu, çift ok simgesi sayfanın vitrin geçişinde olduğunu gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Genel Bilgiler ve yayın'),
      text: t(`${G}.s2.text`, '"Sayfa Başlığı" zorunludur; sekmede ve menülerde bu başlık görünür. "URL Slug" sayfanın adresidir: sayfa /pages/slug adresinde yayınlanır; siz değiştirmedikçe başlıktan otomatik üretilir. "Görüntülenme Sırası"nda küçük değer önce görünür. "Durum" anahtarı Aktif ise sayfa sitede yayındadır ve Header Üst Menüsü\'ndeki "Ara" düğmesinden seçilebilir; Pasif sayfa adresinden açılmaz ve menü seçiminde görünmez.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yeni sayfa Aktif başlar. Hazır olmayan bir sayfayı kaydetmeden önce Pasif yapın.'),
        t(`${G}.s2.tip2`, 'Kayıtlı ve aktif sayfayı başlıktaki "Sayfayı ön yüzde aç" düğmesiyle sitede açıp kontrol edebilirsiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Vitrin Geçiş Butonları'),
      text: t(`${G}.s3.text`, '"Sayfalar arası geçişte göster" açık olan sayfalar sitede birbirine geçiş düğmeleriyle bağlanır. "Geçiş grubu" aynı olan sayfalar birlikte listelenir; boş bırakılırsa varsayılan gruptadır. Ayrı kümeler için farklı ad yazın (ör. Kurumsal, Yasal) ya da mevcut grup çiplerinden seçin.'),
      tips: [
        t(`${G}.s3.tip1`, '"Vitrin önizlemesi" bu sayfanın grubundaki sayfaları gösterir; geçişin görünmesi için aynı grupta en az iki sayfa olmalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. SEO Ayarları'),
      text: t(`${G}.s4.text`, '"Meta Title (SEO)" tarayıcı sekmesinde ve Google sonuçlarında görünecek başlıktır; boş bırakılırsa Sayfa Başlığı kullanılır. "Meta Description (SEO)" alanına sayfayı kısa ve net anlatan 150-160 karakterlik bir açıklama yazın. "Google Önizleme" sonucun aramada nasıl görüneceğini gösterir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Meta açıklama girmezseniz arama motorları içeriğin ilk satırlarını kullanabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Sayfa İçeriği'),
      text: t(`${G}.s5.text`, 'Zengin metin editörüyle başlık, liste, tablo, bağlantı ve görsel ekleyin. Tablo simgesiyle tablo ekleyin; hücreye tıklayınca satır / sütun düzenleme çubuğu açılır. Araç çubuğunun sağındaki düğmelerle sayfaya Form Ekle (Formlar ekranında hazırladığınız bir form), Harita Ekle (Google Haritalar linki), Görsel + Metin (görsel ve açıklama yan yana) veya Görsel Kartlar (ızgara) yerleştirin.'),
      tips: [
        t(`${G}.s5.tip1`, 'Editördeki görsel kart bloğunun üzerindeki "Düzenle" ve "Sil" düğmeleriyle bloğu değiştirebilir veya kaldırabilirsiniz.'),
        t(`${G}.s5.tip2`, 'Sayfalara kart ve etiket blokları Kartlar & Etiketler ekranından eklenir. O ekranın "Sayfa sırası" sekmesinde, aynı sayfadaki kart ve etiket bloklarını yukarı / aşağı alarak vitrindeki sıralarını değiştirebilirsiniz; etiketler kartların arasına da girebilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin, geri alın veya silin'),
      text: t(`${G}.s6.text`, '"Kaydet" sayfadaki tüm değişiklikleri kaydeder. "Sıfırla / Yenile" sayfaları son kaydedilmiş hâliyle yeniden yükler; tüm sekmelerdeki kaydedilmemiş değişiklikler ve henüz kaydedilmemiş yeni sayfalar kaybolur. "Sayfayı Sil" sayfayı kalıcı olarak siler; sayfa header menüsünde kullanılıyorsa o link de geçersiz kalır.'),
      tips: [
        t(`${G}.s6.tip1`, 'En alttaki renkli satır sayfanın yayında mı, pasif mi olduğunu ve yayın adresini gösterir.'),
        t(`${G}.s6.tip2`, 'Sekmelerin yanındaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
